module.exports = __webpack_public_path__ + "../resources/images/SpotlightFre-ad105a737b4c442291e86d5eda37e026.svg";